module.exports = __webpack_public_path__ + "img/Icon_YDP.27fc36f0.png";